import React, { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { CustomModal } from '../../../components/CustomModal';

interface Props {
  closeModal(): void;
  handlerDelete(): void;
}

export const DeleteProjectModal: FC<Props> = ({ closeModal, handlerDelete }) => {
  return (
    <CustomModal title="Удаление проекта" handleClose={closeModal} open={true}>
      <Stack flexDirection="row">
        <Typography fontSize="18px">Вы действительно хотите удалить проект?</Typography>
      </Stack>

      <Stack flexDirection="row" mt={5}>
        <Button
          onClick={closeModal}
          variant="contained"
          color="info"
          style={{
            width: '80%',
            height: '95%',
            marginRight: '2px',
          }}
        >
          <Typography>Отмена</Typography>
        </Button>
        <Button
          onClick={handlerDelete}
          variant="contained"
          color="error"
          style={{
            width: '80%',
            height: '95%',
            marginLeft: '2px',
          }}
        >
          <Typography>Удалить</Typography>
        </Button>
      </Stack>
    </CustomModal>
  );
};
